module.exports = __webpack_public_path__ + "img/icon-article.72fb05ad.svg";